import { UserSession } from '@allocab/allocab-commons-shared-types';
import jwtDecode from 'jwt-decode';

import { useTokens } from './useTokens';

const useTokenInfo = () => {
  const { tokens } = useTokens();

  if (!tokens) return {};

  const session = jwtDecode(tokens.accessToken) as UserSession;

  return { session, isCorporate: session.kind === 'CORPORATE' };
};

export default useTokenInfo;
